<template>
  <viewPersonneMorale
    ref="view"
    :enums="enums"
    :form="form"
    :control="control"
    :dsType="dsType"
    :filiales="filiales"
    :divisions="divisions"
    :contacts="contacts"
  >
    <entiteActions
      :demandeSuppression="demandePMSuppressionPossible"
      :enModeReactivation="this.enModeReactivation"
      :demandeModication="false"
      :type="'personne morale'"
      :id="this.form.id"
    >
      <v-btn text v-if="this.enModeReactivation" @click="reactiverPM">
        Réactiver
      </v-btn>
    </entiteActions>

    <template
      v-if="
        this.control.enDemandeModification ||
          this.control.enDemandeCreation ||
          this.control.enDemandeSuppression
      "
      #zoneBasse
    >
      <v-list-item>
        <v-list-item-content two-line>
          <v-list-item-title class="headline"
            >Raison de la demande</v-list-item-title
          >
          <v-list-item-subtitle
            >Veuillez saisir les raisons motivant cette
            demande</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>
      <v-card-text>
        <v-row dense>
          <v-col cols="12">
            <v-textarea
              counter
              filled
              label="Commentaire"
              v-model="commentaire"
              :rules="[size255Rule(), serveurRule('commentaire')]"
              hide-details="auto"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
    </template>
  </viewPersonneMorale>
</template>

<script>
import Datasource from '@/utils/datasource';
import EditeurEntite from '@/plugins/mixins/EditeurEntite';
import { routeEnter, routeUpdate } from '@/utils/entite';
import ViewPersonneMorale from './ViewPersonneMorale';
import { nettoyageTelephone } from '@/view/personnemorale/personnemoraleUtils';
import { getInternational } from '@/components/telephone/telephoneUtil';
import toasted from '@/utils/toasted';

const routesAction = (withId, withNew) => {
  withId(
    id => `personne-morale/${id}`,
    (vm, body) => {
      vm.initForm(body);
    },
  );
  withNew('enums/personnemorale', (vm, body) => vm.initNew(body));
};

export default {
  components: {
    viewPersonneMorale: ViewPersonneMorale,
  },
  props: {
    enModeCreation: {
      type: Boolean,
      default: false,
    },
    enModeReactivation: {
      type: Boolean,
      default: false,
    },
    enDemandeCreation: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [EditeurEntite],

  beforeRouteEnter: routeEnter(routesAction),
  beforeRouteUpdate: routeUpdate(routesAction),

  data() {
    // Le type de PM
    var dsType;

    return {
      // Datasources
      dsType,

      // Configuration de l'IHM
      panel: [],
      control: {
        readonly: true,
        enDemandeModification: false,
      },

      // Les enums
      enums: {
        contextes: [],
        cotiseA: [],
        types: [],
      },
      commentaire: null,
      // Le formulaire
      form: {
        id: null,
        nomUsuel: null,
        raisonSociale: null,
        sirenOuSiret: null,
        type: {
          id: null,
          libelle: null,
        },
        mail: null,
        fax: null,
        domicilieeMDL: false,
        organisationPro: false,
        siteInternet: null,

        // Collections
        adresses: null,
        telephones: null,
        maisonsMeres: [],
        contextes: [],
        cotiseA: [],

        // RGPD
        dateCreation: null,
        chargeCreation: null,
        dateModification: null,
        chargeModification: null,
        demandeurCreation: null,
      },

      // Obets affichés mais non modifiés
      filiales: null,
      divisions: [],
      contacts: [],
    };
  },
  beforeMount() {
    this.buildDatasource();
  },
  computed: {
    demandePMSuppressionPossible() {
      return this.contacts.length === 0;
    },
  },
  methods: {
    buildDatasource() {
      this.dsType = new Datasource('abstractenum/typepersonnemorale', {
        rowsPerPage: 50,
        sortBy: 'libelle',
      });
    },

    // Gestion de l'initialisation du formulaire
    initForm(loaded) {
      //injection du droit d'edition
      this.control.edition = loaded.edition;

      this.form.dateCreation = loaded.dateCreation || null;
      this.form.chargeCreation = loaded.chargeCreation || null;
      this.form.dateModification = loaded.dateModification || null;
      this.form.demandeurCreation = loaded.demandeurCreation || null;
      this.form.chargeModification = loaded.chargeModification || null;

      this.form.id = loaded.id || null;
      this.form.nomUsuel = loaded.nomUsuel || null;
      this.form.raisonSociale = loaded.raisonSociale || null;
      this.form.sirenOuSiret = loaded.sirenOuSiret || null;

      this.form.type = loaded.type || { id: null, libelle: null };
      this.form.mail = loaded.mail || null;
      this.form.fax = getInternational(loaded.fax) || null;
      this.form.domicilieeMDL = loaded.domicilieeMDL || false;
      this.form.organisationPro = loaded.organisationPro || false;
      this.form.siteInternet = loaded.siteInternet || null;

      // Collections
      this.form.adresses = loaded.adresses || [];
      this.form.telephones = loaded.telephones || [];
      this.form.maisonsMeres = loaded.maisonsMeres || [];
      this.form.contextes = loaded.contextes || [];
      this.form.cotiseA = loaded.cotiseA || [];

      this.filiales = loaded.filiales || [];
      this.divisions = loaded.divisions || [];
      this.contacts = loaded.contacts || [];

      this.sortPersonnesMorales(this.filiales);
      this.sortPersonnesMorales(this.maisonsMeres);
    },
    sortPersonnesMorales(data) {
      if (Array.isArray(data)) {
        data.sort((a, b) => {
          return a.nomUsuel.localeCompare(b.nomUsuel, 'fr', {
            sensitivity: 'base',
            ignorePunctuation: true,
          });
        });
      }
    },
    initNew(body) {
      this.initForm({
        telephones: [],
        maisonsMeres: [],
        adresses: [],
        contextes: [],
        cotiseA: [],
      });
      this.initEnums(body);
      this.__initEdition();

      //question de droit ? on fait une demande de creation ou une création directe ?
      this.control.enDemandeCreation = this.enDemandeCreation;
      this.control.enCreation = !this.enDemandeCreation;
      this.control.readonly = false;
      this.getForms().forEach(f => {
        if (f) {
          f.resetValidation();
        }
      });
    },
    // Appelée après chargement des listes d'enums depuis le Back
    initEnums(body) {
      const enums = this.enums;
      enums.contextes = body.contextes;
      enums.cotiseA = body.cotiseA;
      enums.types = body.types;
    },
    // Appelée par le mixin Entite
    creationPromiseEnums() {
      return this.$api('enums/personnemorale')
        .get()
        .then(response => {
          const body = response.body;
          this.initEnums(body);
        });
    },

    redirectionApresCreation() {
      //le callback pour aller vers le détail de la personne créée
      if (this.$auth.hasRole('PRIV_TRAITEMENT_DEMANDE_PERSONNE_MORALE')) {
        const route = this.$liens().personneMorale(this.form.id);
        this.control.readonly = true;
        this.$router.push(route);
      } else {
        this.$router.push({ name: 'workflow/mesdemandes' });
      }
    },
    actionApresAnnulation(control) {
      if (control.enCreation) {
        this.$router.push({ name: 'home' });
      }
    },

    creationPromiseSauvegarde(id, form) {
      // nettoyage des telephones
      const copy = nettoyageTelephone(form);

      if (this.control.enCreation) {
        return this.$api('personne-morale').put(copy);
      } else if (this.control.enDemandeModification) {
        copy.commentaire = this.commentaire;
        return this.$api(`workflow/personne-morale/${id}`).post(copy);
      } else if (this.control.enDemandeCreation) {
        copy.commentaire = this.commentaire;
        return this.$api('workflow/personne-morale').post(copy);
      } else if (this.control.enDemandeSuppression) {
        return this.$api(`workflow/personne-morale/suppression/${id}`).post({
          commentaire: this.commentaire,
        });
      }

      return this.$api(`personne-morale/${id}`).post(copy);
    },
    getForms() {
      //access aux formulaire à créer
      return this.$refs.view.getForms();
    },
    reactiverPM() {
      const id = this.form.id;
      return this.$api(`workflow/personne-morale/reactivation/${id}`)
        .post()
        .then(() => {
          toasted.info('Personne morale réactivée');
          this.$router.push({ name: 'administration/corbeille/corbeille' });
        });
    },
  },
};
</script>
